/* This code is only meant to be reached from our page <head> tag, so it only runs once per application load */
import { generalDataLayer } from 'gtm';

const isLoggedIn = window.localStorage['isLoggedIn'] == undefined ? false : JSON.parse(window.localStorage['isLoggedIn']);

function commitOptions (event) {
	generalDataLayer(isLoggedIn, Cookiebot.consent);

	window.removeEventListener('CookiebotOnAccept', commitOptions);
	window.removeEventListener('CookiebotOnDecline', commitOptions);
};

function triggerCookieBot () {
	const script = document.createElement('script');
	script.id = 'Cookiebot';
	script.src = 'https://consent.cookiebot.com/uc.js';
	script.type = 'text/javascript';
	script.setAttribute('data-cbid', 'bbf1f049-7d7d-4b23-8d09-ca80841a8eed');

	// Important to append script first in head
	const head = document.getElementsByTagName('head')[0];
	head.insertBefore(script, head.firstChild);
};

function addListeners () {
	window.addEventListener('CookiebotOnAccept', commitOptions);
	window.addEventListener('CookiebotOnDecline', commitOptions);
};

(function getCookie() {
	triggerCookieBot();

	const name = 'CookieConsent=';
	const ca = document.cookie.split(';');
	let cookieValues = null;
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			cookieValues = c.substring(name.length, c.length);
		}
	}
	if (cookieValues) {
		const parsedCookie = JSON.parse(decodeURIComponent(cookieValues).replace(/(['"])?([a-zA-Z0-9]+)(['"])?:/g, '"$2":').replace(/'/g, '"'));

		dataLayer.push({
			'user_info': {
				'is_logged_in': isLoggedIn,
			},
			'cookie_info': {
				'marketing_consent': parsedCookie.marketing,
				'personalisation_consent': parsedCookie.preferences,
				'necessary_consent': parsedCookie.necessary,
				'statistics_consent': parsedCookie.statistics,
			}
		});

	} else {
		dataLayer.push({
			'user_info': {
				'is_logged_in': isLoggedIn,
			},
			'cookie_info': {
				'marketing_consent': false,
				'personalisation_consent': false,
				'necessary_consent': false,
				'statistics_consent': false,
			}
		});

		addListeners();
	}
})();
